export default "__VITE_ASSET__w15Q9GFSxf$SM5fgVrzLCg__"